<template>
  <sidenav :orientation="orientation" :class="curClasses">
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">
       <sidenav-menu  v-for="mod in modItems" :key="mod.l1" :icon="getModuleDescription(mod.l1.toString())[0].ico">
          <template slot="link-text">{{getModuleDescription(mod.l1.toString())[0].desc}}</template>
          <div v-for="(cat, index) in getCategories(mod.l1)" :key="index">
            <sidenav-menu v-if="(mod.l1.toString() === '11' && cat.l2.toString() !== '2') || (mod.l1.toString() !== '11')">
              <template slot="link-text" ><span :class="getCategoryDescription(cat.l2.toString())[0].ico"></span>&nbsp;&nbsp;{{getCategoryDescription(cat.l2.toString())[0].desc}}</template>
                <div v-for="mnu in getMenuItems(mod.l1, cat.l2)" :key="mnu.l0">
                  <sidenav-router-link v-if="mnu.l0.toString() !== '111201'" :to=getMenuDescription(mnu.l0.toString())[0].path >{{getMenuDescription(mnu.l0.toString())[0].desc}}</sidenav-router-link>
                </div>
            </sidenav-menu>
          </div>
        </sidenav-menu>
    </div>
  </sidenav>
</template>

<script>
// import { Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider } from '@/vendor/libs/sidenav'
import { Sidenav, SidenavRouterLink, SidenavMenu } from '@/vendor/libs/sidenav'

const CATEGORY_LIST = [
  { 'id': '1', 'desc': 'Maintenance', 'ico': 'far fa-folder' },
  { 'id': '2', 'desc': 'Transaction', 'ico': 'fas fa-edit' },
  { 'id': '3', 'desc': 'Reports', 'ico': 'ion ion-ios-archive' },
  { 'id': '4', 'desc': 'Inquiry', 'ico': 'fas fa-binoculars' }
]

const MODULE_LIST = [
  { 'id': '1', 'desc': 'System', 'ico': 'ion ion-md-desktop' },
  { 'id': '2', 'desc': 'Human Resources', 'ico': 'fas fa-users' },
  { 'id': '3', 'desc': 'General Ledger', 'ico': 'ion ion-ios-archive' },
  { 'id': '4', 'desc': 'Payment', 'ico': 'fas fa-wallet' },
  { 'id': '5', 'desc': 'Accounts Payable', 'ico': 'fas fa-user-friends' },
  { 'id': '11', 'desc': 'Media Library', 'ico': 'fas fa-user-friends' }
]

const MENU_LIST = [
  { 'id': '101101', 'desc': 'Users', 'path': '/system/mnuser' },
  { 'id': '101102', 'desc': 'Roles', 'path': '/system/mnrole' },
  { 'id': '101103', 'desc': 'Announcements', 'path': '/system/mnannouncement' },
  { 'id': '101104', 'desc': 'Currency', 'path': '/system/mncurrency/' },
  { 'id': '101105', 'desc': 'Currency Base Setup', 'path': '/system/currencybasesetup/' },
  { 'id': '101106', 'desc': 'System Settings', 'path': '/system/settings' },
  { 'id': '102101', 'desc': 'Employees', 'path': '/humanresource/employee' },
  { 'id': '102102', 'desc': 'Units', 'path': '/humanresource/unit' },
  { 'id': '102103', 'desc': 'Departments', 'path': '/humanresource/department' },
  { 'id': '103101', 'desc': 'Account Categories', 'path': '/generalledger/category' },
  { 'id': '103102', 'desc': 'Account Charts', 'path': '/generalledger/accountchart' },
  { 'id': '103103', 'desc': 'Currency Exchange Rates', 'path': '/generalledger/exchangerate' },
  { 'id': '103104', 'desc': 'Posting Setting', 'path': '/generalledger/postingsettingList' },
  { 'id': '103105', 'desc': 'Period Setups', 'path': '/generalledger/periodsetupDTOList' },
  { 'id': '103107', 'desc': 'Account Format Setup', 'path': '/generalledger/formatsetup' },
  { 'id': '103108', 'desc': 'Segments', 'path': '/generalledger/segment' },
  { 'id': '103201', 'desc': 'Batch Entry', 'path': '/generalledger/batchEntry' },
  { 'id': '103202', 'desc': 'General Ledger Entry', 'path': '/generalledger/glentry' },
  { 'id': '104101', 'desc': 'Payment Natures', 'path': '/edisbursement/paymentnature' },
  { 'id': '104102', 'desc': 'Payment Forms', 'path': '/edisbursement/paymentform' },
  { 'id': '104103', 'desc': 'Cash Accounts', 'path': '/edisbursement/cashaccount' },
  { 'id': '104104', 'desc': 'Unit Approval Routing', 'path': '/edisbursement/unitapprovalrouting' },
  { 'id': '104105', 'desc': 'Accounting Review Routing', 'path': '/edisbursement/accountingapprovalrouting' },
  { 'id': '104106', 'desc': 'Accounting Office Sites', 'path': '/edisbursement/officesite' },
  { 'id': '104107', 'desc': 'Unbudgeted Accounts', 'path': '/edisbursement/unbudgetedaccount' },
  { 'id': '104108', 'desc': 'Charge Account Department Access', 'path': '/edisbursement/caodeptaccess' },
  { 'id': '104109', 'desc': 'Originator Department', 'path': '/edisbursement/originatordepartment' },
  { 'id': '104201', 'desc': 'Transaction Entry', 'path': '/edisbursement/disbursement' },
  { 'id': '104202', 'desc': 'Unit Approval', 'path': '/edisbursement/unitapproval' },
  { 'id': '104203', 'desc': 'Accounting Review', 'path': '/edisbursement/accountingapproval' },
  { 'id': '104204', 'desc': 'Vendor Application', 'path': '/edisbursement/vendorapplication' },
  { 'id': '104401', 'desc': 'Transaction Inquiry', 'path': '/edisbursement/disbursementinquiry' },
  { 'id': '104402', 'desc': 'Approval Inquiry', 'path': '/edisbursement/approvalinquiry' },
  { 'id': '104403', 'desc': 'Completed Payment Requests Inquiry', 'path': '/edisbursement/completedpaymentrequestsinquiry' },
  { 'id': '104404', 'desc': 'Approval Logs Inquiry', 'path': '/edisbursement/approvallog' },
  { 'id': '104405', 'desc': 'Payments Inquiry', 'path': '/edisbursement/detaileddisbursement' },
  { 'id': '104406', 'desc': 'Payees Logs Inquiry', 'path': '/edisbursement/payeelog' },
  { 'id': '104407', 'desc': 'New Payees Inquiry', 'path': '/edisbursement/newpayee' },
  { 'id': '104408', 'desc': 'Wire Transfers Inquiry', 'path': '/edisbursement/wiretransfer' },
  { 'id': '104409', 'desc': 'Confidential Completed Payment Requests Inquiry', 'path': '/edisbursement/completedprconfidentialsInquiry' },
  { 'id': '104410', 'desc': 'Wire Transfers-CAO Review Inquiry', 'path': '/edisbursement/accountingwiretransfer' },
  { 'id': '104411', 'desc': 'Completed BT Payment Requests Inquiry', 'path': '/edisbursement/completedpriotinquiry' },
  { 'id': '104412', 'desc': 'Funds Transfer Inquiry', 'path': '/edisbursement/fundtransfer' },
  { 'id': '104413', 'desc': 'Transmittal Inquiry', 'path': '/edisbursement/disbursementtransmittal' },
  { 'id': '105101', 'desc': 'Vendors', 'path': '/accountspayable/vendor' },
  { 'id': '105102', 'desc': 'Shipping Method Master', 'path': '/accountspayable/shippingmethod' },
  { 'id': '105103', 'desc': 'Tax Detail Maintenance', 'path': '/accountspayable/taxdetail' },
  { 'id': '105104', 'desc': 'Tax Schedule', 'path': '/accountspayable/taxschedule' },
  { 'id': '105105', 'desc': 'Tax Detail History', 'path': '/accountspayable/taxdetailhistory' },
  { 'id': '199101', 'desc': 'Chart of Accounts', 'path': '/enterprise/erpchartofaccount' },
  { 'id': '199102', 'desc': 'Vendors', 'path': '/enterprise/erpvendor' },
  { 'id': '199103', 'desc': 'AA Accounts', 'path': '/enterprise/erpaag00200' },
  { 'id': '199104', 'desc': 'AA Account - Class IDs', 'path': '/enterprise/erpaag00201' },
  { 'id': '199105', 'desc': 'AA Class IDs - Transaction Dimension', 'path': '/enterprise/erpaag00202' },
  { 'id': '199106', 'desc': 'AA Transaction Dimensions', 'path': '/enterprise/erpaag00400' },
  { 'id': '199107', 'desc': 'AA Transaction Dimension - Codes', 'path': '/enterprise/erpaag00401' },
  { 'id': '101201', 'desc': 'User Registration Approval', 'path': '/system/userregapproval' },
  { 'id': '111101', 'desc': 'Videos', 'path': '/medialibrary/video' },
  { 'id': '111102', 'desc': 'Books', 'path': '/medialibrary/book' },
  { 'id': '111103', 'desc': 'Video Category', 'path': '/medialibrary/videocat' },
  { 'id': '111104', 'desc': 'Book Category', 'path': '/medialibrary/bookcat' },
  { 'id': '111105', 'desc': 'Video Group', 'path': '/medialibrary/videogrp' },
  { 'id': '111106', 'desc': 'Book Group', 'path': '/medialibrary/bookgrp' },
  { 'id': '111107', 'desc': 'User Assignment', 'path': '/medialibrary/userassign' },
  { 'id': '111108', 'desc': 'User Group Book', 'path': '/medialibrary/usergrpbook' },
  { 'id': '111110', 'desc': 'Books Uploading', 'path': '/medialibrary/bookupload' },
  { 'id': '111111', 'desc': 'Media Library Settings', 'path': '/medialibrary/settings' },
  { 'id': '111201', 'desc': 'User Home Page', 'path': '/userhome' },
  { 'id': '111203', 'desc': 'Book Assignment', 'path': '/medialibrary/bookassign' },
  { 'id': '111204', 'desc': 'User Registration Approval', 'path': '/medialibrary/userregapproval' },
  { 'id': '111205', 'desc': 'Account Profile', 'path': '/medialibrary/accountprofile' },
  { 'id': '111401', 'desc': 'Books Download', 'path': '/medialibrary/booksdownloadinquiry' },
  { 'id': '111402', 'desc': 'Videos Viewed', 'path': '/medialibrary/videosviewedinquiry' }
]
// add GL menu
export default {
  name: 'app-layout-sidenav',
  components: {
    Sidenav,
    // SidenavLink,
    SidenavRouterLink,
    SidenavMenu
    // SidenavHeader,
    // SidenavBlock,
    // SidenavDivider
  },

  data () {
    return {
      menuItems: JSON.parse(localStorage.getItem('l0')),
      modItems: JSON.parse(localStorage.getItem('l1')),
      catItems: JSON.parse(localStorage.getItem('l2')),
      menuNames: MENU_LIST,
      moduleNames: MODULE_LIST,
      categoryNames: CATEGORY_LIST
    }
  },

  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },

  computed: {
    curClasses () {
      let bg = this.layoutSidenavBg

      if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '')
      }

      return `bg-${bg} ` + (
        this.orientation !== 'horizontal'
          ? 'layout-sidenav'
          : 'layout-sidenav-horizontal container-p-x flex-grow-0'
      )
    }
  },

  methods: {
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0
    },

    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },

    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    },
    getMenuItems: function (mod, cat) {
      return this.menuItems.filter(function (item) {
        return item.l1 === mod && item.l2 === cat
      })
    },
    getCategories: function (mod) {
      return this.catItems.filter(function (item) {
        return item.l1 === mod
      })
    },
    getMenuDescription: function (id) {
      return this.menuNames.filter(function (item) {
        return item.id === id
      })
    },
    getModuleDescription: function (id) {
      return this.moduleNames.filter(function (item) {
        return item.id === id
      })
    },
    getCategoryDescription: function (id) {
      return this.categoryNames.filter(function (item) {
        return item.id === id
      })
    }
  }
}
</script>
